<template>
    <div>
        <ul class="p-0 text-sm list-none">
            <li
                v-for="(tab, index) in tabs"
                :key="tab.title"
                :class="`${tab.bgcolor} ${index == selectedIndex ? 'underline bg-white text-gray-600' : ''}`"
                class="inline-block px-4 py-2 m-0 mr-1 text-black cursor-pointer hover:bg-white hover:text-gray-600"
                @mouseenter="selectTab(index)"
                @click="clickTab(tab)"
            >
                {{ tab.title }}
            </li>
        </ul>

        <div class="relative">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        status: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            selectedIndex: null, // the index of the selected tab,
            tabs: [], // all of the tabs
        };
    },

    watch: {
        status: {
            immediate: true,
            handler(newVal) {
                if (newVal === false) {
                    this.closeTabs();
                }
            },
        },
    },

    created() {
        this.tabs = this.$children;
    },

    methods: {
        selectTab(i) {
            if (i === 0) {
                return;
            }
            if (this.selectedIndex !== i) {
                this.selectedIndex = i;

                // loop over all the tabs
                this.tabs.forEach((tab, index) => {
                    // eslint-disable-next-line no-param-reassign
                    tab.isActive = (index === i);
                });
            }
        },

        closeTabs() {
            this.selectedIndex = null;
            this.tabs.forEach((tab) => {
                // eslint-disable-next-line no-param-reassign
                tab.isActive = false;
            });
        },

        clickTab(tab) {
            if (tab.click) {
                if (tab.clickparam) {
                    tab.click(tab.clickparam);
                } else {
                    tab.click();
                }
            }
        },
    },
};
</script>
